// extracted by mini-css-extract-plugin
export default {"applicationsList":"applicationsList__xtxu3","applicationItem":"applicationItem__EjUm4","applicationImage":"applicationImage__BJqJc"};